/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandAnsible = createReactComponent("brand-ansible", "IconBrandAnsible", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9.647 12.294l6.353 3.706l-4 -9l-4 9", key: "svg-1" }]
]);

export { IconBrandAnsible as default };
//# sourceMappingURL=IconBrandAnsible.js.map
